// End-of-run bookkeeping (shards, records, run history, map bests / unlocks, endless records), shared by main.ts and the tests.
// TRAINING (owner rule 2026-11-02): a training run never writes anything to the save — no shards, records, history,
// unlocks, endless records or Encyclopedia — so settleRun returns null for it and leaves the profile untouched. The same
// goes for the tutorial's Basics lesson (SimOptions.calm): both are `sim.practice`.
// (Achievements / quests / challenges: FeatTracker in src/app/feats.ts skips training runs on its own.)
import { modList } from '../core/mods';
import type { Sim } from '../core/sim';
import { recordEndless, type EndlessRecordResult } from './endlessSave';
import { recordMapRun } from './mapSave';
import { recordRun, type Profile } from './save';

export interface Settled { paid: number; newBest: string[]; unlocked: string[]; /** endless records (null: not an endless run) */ endless: EndlessRecordResult | null }

/** pay out and record a finished run; null = nothing recorded (training). `difficulty` = the Run Setup difficulty played. */
export function settleRun(profile: Profile, sim: Sim, victory: boolean, mapsAll: boolean, difficulty?: string): Settled | null {
  if (sim.practice) return null; // TRAINING or the Basics lesson (tutorial): practice records nothing
  const paid = sim.shardPayout;
  const res = recordRun(profile, { shards: paid, time: sim.time, kills: sim.kills, level: sim.player.level, victory, mods: modList(sim.mods), difficulty, form: sim.bestSurgeTier });
  // MAP SYSTEM: best time on this map, and whatever that opens (never saved under ?mapsall)
  const mr = mapsAll ? { newBest: false, unlocked: [] as string[] } : recordMapRun(profile.maps, sim.map.id, sim.time);
  // ENDLESS GOALS: best endless time / tier, overall and on this map (never saved under ?mapsall)
  const endless = sim.endless ? recordEndless(profile, sim.map.id, Math.floor(sim.endlessTime), sim.endlessTier, mapsAll) : null;
  return { paid, newBest: res.newBest, unlocked: mr.unlocked, endless };
}
